import { getComponent } from '../utils'
import { h } from 'vue'
import { prefix } from '../prefix'
import Layout from '@/layouts/main-layout.vue'
import { BookOutlined } from '@ant-design/icons-vue'
import type { RouteRecordRaw } from 'vue-router'

export const data_routes: RouteRecordRaw[] = [
  {
    path: '/data/list',
    name: 'data-list',
    component: () => getComponent(`pages/data/data-list.vue`),
    meta: {
      title: () => 'Data List',
      layout: Layout,
      is_public: false,
      menu: {
        key: 'Data',
        label: 'Data',
        icon: () => h(BookOutlined),
        path: `${prefix}/data/list`,
      },
    },
  },
  {
    path: '/data/:id(\\d+)+',
    name: 'data-details',
    component: () => getComponent(`pages/data/data-details.vue`),
    meta: {
      title: ({ id }: { id: string }) => `Data #${id}`,
      layout: Layout,
      is_public: false,
    },
  },
  {
    path: '/data/new',
    name: 'data-new',
    component: () => getComponent(`pages/data/data-new.vue`),
    meta: {
      title: () => `New Data`,
      layout: Layout,
      is_public: false,
    },
  },
  {
    path: '/data/:id(\\d+)+/edit',
    name: 'data-edit',
    component: () => getComponent(`pages/data/data-edit.vue`),
    meta: {
      title: () => `Edit Data`,
      layout: Layout,
      is_public: false,
    },
  },
]
